module.exports = __webpack_public_path__ + "static/media/mreavesxlsannarr-020415006EmigreWebOnly.063ae739.woff2";